<template>
<div class="container pt-5 pb-5">
    <div class="row">
        <div class="col-md-12 text-center mb-5">
            <h1>Onze Partners:</h1>
        </div>
        <div class="col-md-4 offset-md-2">
            <a href="https://veiligheidsteam.nl" target="_blank">
                <card icon="/img/veiligheidsteam-200x14.webp" title="VEILIGHEIDSTEAM.NL" description="Van plan tot levering en coördinatie van professionals. Totale ontzorging voor elk veiligheidsvraagstuk."></card>
            </a>
        </div>
        <div class="col-md-4">
            <a href="https://rijnlandbeveiliging.nl" target="_blank">
                <card icon="/img/rijnland.webp" title="RIJNLAND BEVEILIGING" description="Gecertificeerde beveiligings professionals en technologische oplossingen. Want zonder adequate opvolging is technologische innovatie waardeloos."></card>
            </a>
        </div>
        <div class="col-md-12  text-center">
            <h4 class="text-muted">Ook partner worden? Mail ons!</h4>
        </div>
    </div>
</div>
</template>

<script>
import Card from '@/components/Card'
export default {
    components: {
        Card
    }
}
</script>

<style scoped lang="scss">
a {
    text-decoration: none;
    color: $darkColor;
}
</style>